import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { GREAT_WHITE } from 'HubStyleTokens/colors';
import HR from 'UIComponents/elements/HR';
import UIFlex from 'UIComponents/layout/UIFlex';
import { fetchFeatureInterest } from 'pricing-pages-lib/api/featureInterestApi';
import { fetchLimitUsage } from 'pricing-pages-lib/api/fetchLimitUsage';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { filterLimits, sortLimits } from 'pricing-pages-lib/utils/usageLimitUtils';
import { STARTER } from 'self-service-api/constants/ProductLevels';
import { useIsInActiveTrial } from '../../../../hooks/useIsInActiveTrial';
import { useAppSelector } from '../../../../reducers';
import { isUngatedForGrowthCalculatedFeaturesTranslated } from '../../../../selectors/GatingSelectors';
import { hasPricingAndPurchasingSucceededSelector } from '../../../../selectors/LoadingStateSelectors';
import { productsFromProductInventorySelector } from '../../../../selectors/ProductInventorySelectors';
import LimitUsageSection from '../../suite-starter-page/limit-usage/LimitUsageSection';
import FeatureInterestSection from './FeatureInterestSection';
import TeamMemberFeatureInterest from './TeamMemberFeatureInterest';
const VerticalLineBreak = styled.div.withConfig({
  displayName: "FeatureInterestAndLimitUsageSection__VerticalLineBreak",
  componentId: "mplzlf-0"
})(["width:1px;background-color:", ";margin:0 50px;"], GREAT_WHITE);

const FeatureInterestAndLimitUsageSection = () => {
  const [fetchedData, setFetchedData] = useState({
    isFetching: true,
    limitUsages: [],
    featureInterest: []
  });
  const isUngatedForCalculatedFeaturesTranslated = useAppSelector(isUngatedForGrowthCalculatedFeaturesTranslated);
  useEffect(() => {
    Promise.all([fetchLimitUsage(), fetchFeatureInterest(STARTER, isUngatedForCalculatedFeaturesTranslated)]).then(([limitUsageResponse, featureInterestResponse]) => {
      setFetchedData({
        isFetching: false,
        limitUsages: sortLimits(filterLimits(limitUsageResponse)),
        featureInterest: featureInterestResponse
      });
    }).catch(() => {
      setFetchedData({
        isFetching: false,
        limitUsages: [],
        featureInterest: []
      });
    });
  }, [isUngatedForCalculatedFeaturesTranslated]);
  const ownedProducts = useSelector(state => {
    const hasPricingAndPurchasingSucceeded = hasPricingAndPurchasingSucceededSelector(state);
    if (!hasPricingAndPurchasingSucceeded) return [];
    return productsFromProductInventorySelector(state);
  });
  const isInTrial = useIsInActiveTrial();
  const isPaidPortal = ownedProducts && ownedProducts.length > 0; // Usage data isn't accurate for paid / trialing portals.

  const showLimitUsage = !isPaidPortal && !isInTrial && fetchedData.limitUsages && fetchedData.limitUsages.length > 0; // Showing feature interest for paid portals may be misleading by showing features that the portal already has access to.

  const showFeatureInterest = !isPaidPortal && fetchedData.featureInterest && fetchedData.featureInterest.length > 0;

  if (fetchedData.isFetching) {
    return /*#__PURE__*/_jsx(UILoadingSpinner, {
      minHeight: 200
    });
  }

  if (showLimitUsage && showFeatureInterest) {
    return /*#__PURE__*/_jsxs("div", {
      style: {
        width: '100%'
      },
      className: "m-top-6",
      children: [/*#__PURE__*/_jsx(HR, {
        distance: "extra-large"
      }), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(TeamMemberFeatureInterest, {
          featureInterest: fetchedData.featureInterest
        }), /*#__PURE__*/_jsxs("div", {
          className: "display-flex",
          children: [/*#__PURE__*/_jsx(LimitUsageSection, {
            limitUsages: fetchedData.limitUsages
          }), /*#__PURE__*/_jsx(VerticalLineBreak, {}), /*#__PURE__*/_jsx(FeatureInterestSection, {
            featureInterest: fetchedData.featureInterest
          })]
        })]
      }), /*#__PURE__*/_jsx(HR, {
        distance: "extra-large"
      })]
    });
  }

  if (showLimitUsage || showFeatureInterest) {
    return /*#__PURE__*/_jsxs("div", {
      style: {
        width: '100%'
      },
      className: "m-top-6",
      children: [/*#__PURE__*/_jsx(HR, {
        distance: "extra-large"
      }), /*#__PURE__*/_jsxs(UIFlex, {
        align: "center",
        direction: "column",
        children: [/*#__PURE__*/_jsx(TeamMemberFeatureInterest, {
          featureInterest: fetchedData.featureInterest,
          width: "100%"
        }), /*#__PURE__*/_jsxs("div", {
          className: "display-flex justify-center",
          style: {
            width: '100%'
          },
          children: [showLimitUsage && /*#__PURE__*/_jsx(LimitUsageSection, {
            limitUsages: fetchedData.limitUsages,
            width: "100%"
          }), showFeatureInterest && /*#__PURE__*/_jsx(FeatureInterestSection, {
            featureInterest: fetchedData.featureInterest
          })]
        })]
      }), /*#__PURE__*/_jsx(HR, {
        distance: "extra-large"
      })]
    });
  }

  return null;
};

export default FeatureInterestAndLimitUsageSection;